import { JOIN_TO_ACCESS_TEXT } from "lib/constants/shared";
import {
  SIFTED_INSIGHTS_FEATURE_CARD_VARIANTS,
  type SiftedInsightsFeatureCardVariant,
} from "./siftedInsightsFeatureCard.types";

export const SPONSORSHIP_TYPE_DEFAULTS = {
  SPONSOR_NAME: "sponsor",
  SPONSOR_ALT_TEXT: "Sponsor",
} as const;

export const LINK_DEFAULTS = {
  REL_EXTERNAL: "noopener noreferrer",
  TARGET_EXTERNAL: "_blank",
} as const;

export const HOVER_NOT_JOINED_DEFAULT_TEXT = JOIN_TO_ACCESS_TEXT;

export const FEATURE_CARD_VARIANT_STYLES = {
  [SIFTED_INSIGHTS_FEATURE_CARD_VARIANTS.SIFTED]: {
    interactiveBorder:
      "group-hover:border-sifted group-focus-visible:border-sifted",
    rightLabel: "text-sifted",
    buttonAccent: "sifted" as const,
    statusOverlay: "bg-sifted",
    statusBorder: "border-sifted",
    statusText: "text-sifted",
    textOnlyAction: "text-sifted",
  },
  [SIFTED_INSIGHTS_FEATURE_CARD_VARIANTS.PRO]: {
    interactiveBorder: "group-hover:border-pro group-focus-visible:border-pro",
    rightLabel: "text-pro",
    buttonAccent: "pro" as const,
    statusOverlay: "bg-pro",
    statusBorder: "border-pro",
    statusText: "text-pro",
    textOnlyAction: "text-black-rock",
  },
} as const satisfies Record<
  SiftedInsightsFeatureCardVariant,
  Record<string, string>
>;
